import reducer from "./reducer";
export { default as MyAnnotations } from "./components/index";
export { default as myAnnotationsReducerName } from "./constants";
export default reducer;
